export const GoogleCalenderIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20150_43388)">
        <path
          d="M5.33252 7.99756C5.33252 4.40901 8.28756 1.5 11.9329 1.5H28.0671C31.7124 1.5 34.6675 4.40901 34.6675 7.99756V14.8561C34.6675 18.4446 31.7124 21.3537 28.0671 21.3537H11.9329C8.28756 21.3537 5.33252 18.4446 5.33252 14.8561V7.99756Z"
          fill="#BBE2FF"
        />
        <path
          d="M2.55188 10.8382C2.08229 7.32496 4.86041 4.20703 8.45967 4.20703H31.5403C35.1398 4.20703 37.9177 7.32496 37.4481 10.8382L36.0426 21.3534L37.4481 31.8686C37.9177 35.3818 35.1398 38.4997 31.5403 38.4997H8.45967C4.86018 38.4997 2.08229 35.3818 2.55188 31.8686L3.95744 21.3534L2.55188 10.8382Z"
          fill="#3C90FF"
        />
        <mask
          id="mask0_20150_43388"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="3"
          y="2"
          width="8"
          height="7"
        >
          <path
            d="M3.36919 3.6272C3.27954 2.95654 3.80988 2.36133 4.49698 2.36133H8.90304C9.59018 2.36133 10.1205 2.95654 10.0308 3.6272L9.76251 5.63454L10.0308 7.64188C10.1205 8.31254 9.59018 8.90775 8.90304 8.90775H4.49698C3.80984 8.90775 3.27954 8.31254 3.36919 7.64188L3.63751 5.63454L3.36919 3.6272Z"
            fill="#3186FF"
          />
        </mask>
        <g mask="url(#mask0_20150_43388)">
          <g filter="url(#filter0_f_20150_43388)">
            <path
              d="M5.33252 5.83171C5.33252 3.43934 7.30255 1.5 9.73276 1.5H30.2672C32.6975 1.5 34.6675 3.43934 34.6675 5.83171V21.3537H5.33252V5.83171Z"
              fill="url(#paint0_linear_20150_43388)"
            />
          </g>
        </g>
        <path
          d="M15.2681 29.7772C14.3083 29.7772 13.485 29.6236 12.7983 29.3163C12.1115 29.009 11.5301 28.598 11.0542 28.0833C10.5859 27.5608 10.2542 27.05 10.0591 26.5508C9.864 26.0516 9.78601 25.7481 9.82512 25.6404C9.86767 25.5298 9.9513 25.4391 10.0591 25.3868L11.3586 24.8799C11.4676 24.8262 11.5769 24.8185 11.6863 24.8569C11.7954 24.8876 11.9241 25.0642 12.0725 25.3868C12.2286 25.7095 12.4471 26.0513 12.7279 26.4125C13.0089 26.7596 13.3596 27.0459 13.7581 27.2535C14.1562 27.4533 14.6478 27.5531 15.2328 27.5531C16.1771 27.5531 16.9262 27.2843 17.4804 26.7466C18.0422 26.2089 18.3231 25.5252 18.3231 24.6956C18.3231 23.7967 18.0265 23.1053 17.4334 22.6213C16.8405 22.1296 16.0562 21.8838 15.0807 21.8838H13.8518C13.739 21.8857 13.6299 21.8444 13.5475 21.7687C13.4695 21.6842 13.4305 21.5882 13.4303 21.4806V20.2477C13.4303 20.1323 13.4693 20.0363 13.5472 19.9596C13.5865 19.9191 13.6338 19.887 13.6862 19.8652C13.7386 19.8434 13.7949 19.8324 13.8518 19.8328H14.9168C15.7909 19.8328 16.4932 19.5984 17.0239 19.1298C17.5545 18.6611 17.8198 18.0542 17.8198 17.3091C17.8198 16.5718 17.5818 15.9765 17.1057 15.5232C16.6296 15.0699 15.9742 14.8432 15.1393 14.8432C14.671 14.8432 14.2652 14.92 13.9219 15.0738C13.5824 15.2245 13.2792 15.4445 13.0323 15.719C12.7882 15.9805 12.5725 16.2663 12.3885 16.5718C12.2091 16.8638 12.0647 17.0251 11.9553 17.0557C11.8463 17.0788 11.7409 17.0596 11.6393 16.9982L10.4102 16.4105C10.3088 16.3567 10.2425 16.2721 10.2113 16.1569C10.1801 16.0417 10.2738 15.7729 10.4923 15.3504C10.7185 14.9202 11.0618 14.4823 11.5222 14.0366C11.9841 13.5872 12.5336 13.2344 13.1377 12.9995C13.7542 12.7536 14.4721 12.6307 15.2915 12.6309C16.8133 12.6309 18.0189 13.0264 18.9084 13.8176C19.7981 14.6012 20.2429 15.6383 20.2429 16.929C20.2429 17.8201 20.0244 18.5921 19.5875 19.2451C19.1581 19.8978 18.5494 20.3588 17.7614 20.628V20.6741C18.7134 20.9505 19.4625 21.4575 20.0087 22.1949C20.5629 22.9248 20.8399 23.7967 20.8397 24.8106C20.8397 26.2627 20.3247 27.4534 19.2946 28.3829C18.2648 29.3124 16.9226 29.7772 15.2679 29.7772H15.2681ZM27.0136 29.5121C26.881 29.5121 26.7638 29.4622 26.6622 29.3623C26.5699 29.2658 26.5196 29.1377 26.522 29.0052V16.1914L23.8883 18.0581C23.7944 18.1273 23.6851 18.1504 23.5603 18.1274C23.4478 18.1071 23.3474 18.0453 23.2796 17.9546L22.5187 16.8942C22.4502 16.8011 22.4208 16.6855 22.4366 16.5716C22.46 16.4489 22.5224 16.3529 22.6239 16.2837L27.2943 12.9995C27.3334 12.9688 27.3764 12.9458 27.4231 12.9305C27.47 12.9075 27.5246 12.896 27.587 12.896H28.5704C28.703 12.896 28.8084 12.9421 28.8864 13.0343C28.9723 13.1185 29.0152 13.226 29.0152 13.3569V29.0052C29.0152 29.1435 28.9645 29.2626 28.8631 29.3623C28.8189 29.4107 28.7647 29.4492 28.704 29.475C28.6434 29.5009 28.5778 29.5135 28.5117 29.5121H27.0136Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_20150_43388"
          x="-57.5281"
          y="-61.3606"
          width="155.056"
          height="145.575"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="31.4303"
            result="effect1_foregroundBlur_20150_43388"
          />
        </filter>
        <linearGradient
          id="paint0_linear_20150_43388"
          x1="18.4095"
          y1="4.60213"
          x2="18.4095"
          y2="21.4416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A8FF" />
          <stop offset="0.8" stopColor="#3C90FF" />
        </linearGradient>
        <clipPath id="clip0_20150_43388">
          <rect width="35" height="37" fill="white" transform="translate(2.5 1.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
